import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  validate,
  orderALaCartShop,
  validateOrder
} from "../../routes/AdminRoutes";
import { Route, Redirect } from "react-router-dom";
import { Validate } from "../../views";
import OrderALaCartShop from "../../views/Validate/OrderALaCartShop";
import ValidateOrderContainer from "../../views/Validate/ValidateOrderContainer";
import { useDispatch, useSelector } from "react-redux";
import { resetTableStatus } from "../../redux/actions/tablesActions";
import { adminConsoleRoot } from "../../routes/Routes";

export default function AdminValidate(props) {
  const dispatch = useDispatch();
  const adminValidate = useSelector(
    state =>
      (state.userState.user.permissions.allowValidate &&
        state.userState.user.permissions.isAdmin) ||
      (state.userState.user.permissions.allowValidate &&
        ((state.userState.user.permissions.validateEnableMysteryShopReview &&
          state.userState.user.permissions.isEmployeeManager) ||
          state.userState.user.permissions.allowValidateRole))
  );

  const isAdmin = useSelector(
    state => state.userState.user.permissions.isAdmin
  );

  if (!adminValidate) {
    return <Redirect to={adminConsoleRoot} />;
  }

  useEffect(() => {
    return () => {
      dispatch(resetTableStatus("validateOrders"));
    };
  }, []);

  return (
    <>
      <Route exact path={validate} component={Validate} />
      <Route path={validateOrder} component={ValidateOrderContainer} />
      {isAdmin && (
        <Route path={orderALaCartShop} component={OrderALaCartShop} exact />
      )}
    </>
  );
}

AdminValidate.propTypes = {
  match: PropTypes.any
};
